<template>
    <StandardArticle
      :title="post.title"
      :preview-image-src="ImageSource"
      :preview-image-alt="post.previewImageAlt"
      v-if="post"
    >
    <div v-html="post.body" />
    </StandardArticle>
  <div v-else>
    <p>Could not get blog post at this time.</p>
  </div>
</template>

<script>
import * as jacktearleapi from '@/api/api.jacktearle.dev.js'
import StandardArticle from '@/components/article/Standard-Article.vue'

export default {
  name: 'blogdetail',
  components: {
    StandardArticle
  },
  data () {
    return {
      errors: [],
      post: undefined
    }
  },
  created () {
    jacktearleapi.GetPost(this.$route.params.postid)
      .then(response => {
        this.post = response.data
      })
      .catch(e => {
        this.errors.push(e)
      })
  },
  computed: {
    ImageSource () {
      return jacktearleapi.GetPostImage(this.post.id, this.post.previewImageSrc)
    }
  }
}
</script>

<style>
</style>
